// Chinese Simplified (zh-CN) translations.
// Keys must exactly match ko.ts. Missing keys fall back to ko-KR at runtime.

const zh = {
  'nav.home_label': '前往主页仪表板',
  'nav.expand': '展开菜单',
  'nav.collapse': '收起菜单',
  'nav.api_connected': 'API 已连接',

  'nav.group.business': 'Business',
  'nav.group.manufacturing': 'Manufacturing',
  'nav.group.field': 'Field',
  'nav.group.admin': 'Admin',

  'nav.item.customer_master': '客户主数据',
  'nav.item.customer_documents': '客户文件',
  'nav.item.inbound': '入站现况(自动)',
  'nav.item.demo_conversion': '演示→签约转化',
  'nav.item.inquiry': '引入咨询现况(手填)',
  'nav.item.deals': '销售管道',
  'nav.item.contracts': '合同',
  'nav.item.stores': '门店',
  'nav.item.robots': '机器人',
  'nav.item.reports': '报告收件箱',
  'nav.item.service_orders': '服务工单',
  'nav.item.triage_queue': '分类队列',
  'nav.item.infrastructure': '日历 · 基础设施订单',
  'nav.item.fleet_tracker': '追踪·分析',
  'nav.item.privacy_requests': 'DSAR 收件箱',
  'nav.item.audit_logs': '审计日志',
  'nav.item.users': '用户',
  'nav.item.incomplete_records': '未填写收件箱',
  'nav.item.option_groups': '选项组',
  'nav.item.retire_candidates': '回收审核',
  'nav.item.self_check_logs': '自检日志',
  'nav.item.production_plan': '制造计划',
  'nav.item.assignments': '机器人分配',
  'nav.item.install_calendar': '安装日程',

  'topbar.logout': '退出登录',

  'role.admin': '管理员',
  'role.manager': '经理',
  'role.sales_manager': '销售团队经理',
  'role.mfg_manager': '制造团队经理',
  'role.field_manager': '现场团队经理',
  'role.viewer': '查看者',

  'owner.honeycomb_robotics': '蜂巢机器人',
  'owner.beyond_honeycomb': '超越蜂巢',

  'locale.ko': '한국어',
  'locale.ja': '日本語',
  'locale.zh': '简体中文',

  'common.loading': '加载中…',
  'common.no_results': '无结果',
  'common.error_load': '无法加载数据',
  'common.cancel': '取消',
  'common.confirm': '确认',
  'common.save': '保存',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.close': '关闭',
  'common.submit': '提交',
  'common.processing': '处理中…',
  'common.search_placeholder': '搜索…',
  'common.all': '全部',
  'common.none': '无',
  'common.yes': '是',
  'common.no': '否',
  'common.items_count': '{count, number}条',
  'common.page_of': '{page} / {total}',
  'common.prev': '上一页',
  'common.next': '下一页',
  'common.csv_export': '导出 CSV',
  'common.exporting': '导出中…',
  'common.assign_me': '分配给我',
  'common.assigned_to_me': '已分配给我',
  'common.open_only': '仅未完成',
  'common.unresolved_only': '仅未解决',
  'common.update_failed': '更新失败',
  'common.danger_irreversible': '此操作无法撤销。',

  'entity.honeycomb_robotics': '蜂巢机器人',
  'entity.beyond_honeycomb': '超越蜂巢',

  'so.page_title': '服务工单收件箱',
  'so.triage_title': '服务工单分类队列',
  'so.new_title': '新建服务工单',
  'so.empty': '没有处理中的服务工单',
  'so.empty_sub': '有新受理时将显示在此处。',
  'so.select_prompt': '请选择服务工单。',

  'so.col.status': '状态',
  'so.col.category': '类别',
  'so.col.robot': '机器人',
  'so.col.customer': '客户',
  'so.col.assignee': '负责人',
  'so.col.created': '受理时间',
  'so.col.sla': 'SLA',

  'so.status.open': '新建',
  'so.status.triaged': '已分类',
  'so.status.assigned': '已分配',
  'so.status.in_progress': '进行中',
  'so.status.blocked': '等待中',
  'so.status.resolved': '已解决',
  'so.status.verified': '已验证',
  'so.status.closed': '已关闭',
  'so.status.cancelled': '已取消',

  'so.category.preventive': '预防性检查',
  'so.category.reactive': '故障响应',
  'so.category.install': '安装',
  'so.category.removal': '拆除',
  'so.category.parts_swap': '零件更换',

  'so.action.triage': '分类',
  'so.action.assign_me': '分配给我并审核',
  'so.action.transition': '更改状态',
  'so.action.cancel': '取消',
  'so.action.restore': '恢复',
  'so.action.reassign_customer': '重新分配客户',
  'so.action.resolve': '解决',

  'so.cancel_reason_required': '取消原因（必填）',
  'so.cancel_confirm_title': '取消服务工单',
  'so.restore_confirm_title': '恢复服务工单',
  'so.restore_confirm_msg': '确定要恢复此服务工单吗？',

  'reports.page_title': '报告收件箱',
  'reports.empty': '没有待处理的报告',
  'reports.empty_sub': '客户扫描QR码发送报告后将显示在此处。',
  'reports.select_prompt': '请选择报告。',

  'reports.col.urgency': '紧急度',
  'reports.col.id': 'ID',
  'reports.col.status': '状态',
  'reports.col.robot': '机器人',
  'reports.col.category': '类别',
  'reports.col.preview': '预览',
  'reports.col.submitted_at': '提交时间',

  'reports.status.new': '新建',
  'reports.status.triaged': '已分类',
  'reports.status.assigned': '已分配',
  'reports.status.in_progress': '进行中',
  'reports.status.resolved': '已解决',
  'reports.status.dismissed': '已驳回',
  'reports.status.duplicate': '重复',

  'reports.severity.urgent': '紧急',
  'reports.severity.normal': '普通',
  'reports.urgency_filter.urgent_only': '仅紧急',
  'reports.urgency_filter.normal_only': '仅普通',

  'reports.category.hardware_failure': '硬件故障',
  'reports.category.cooking_quality': '烹饪质量',
  'reports.category.cleaning_hygiene': '清洁·卫生',
  'reports.category.dispensing': '出料·供应',
  'reports.category.connectivity': '通信',
  'reports.category.ui_ux': 'UI',
  'reports.category.other': '其他',

  'reports.detail.category': '类别',
  'reports.detail.urgency': '紧急度',
  'reports.detail.robot': '机器人',
  'reports.detail.store': '门店',
  'reports.detail.contact': '联系方式',
  'reports.detail.description': '详细内容',
  'reports.detail.current_status': '当前状态',

  'reports.action.assign_me': '分配给我',
  'reports.action.in_progress': '进行中',
  'reports.action.resolve': '解决',
  'reports.action.dismiss': '驳回',
  'reports.action.resolve_label': '解决',
  'reports.action.dismiss_label': '驳回',

  'reports.modal.resolve_title': '解决报告',
  'reports.modal.resolve_note_label': '解决备注',
  'reports.modal.resolve_note_required': '解决备注（必填）',
  'reports.modal.dismiss_title': '驳回报告',
  'reports.modal.dismiss_reason_label': '驳回原因',
  'reports.modal.dismiss_reason_required': '驳回原因（必填）',

  'dsar.page_title': '个人信息请求 (DSAR) 收件箱',
  'dsar.empty': '没有待处理的DSAR请求',
  'dsar.empty_sub': '客户通过 /privacy/request 提交后将显示在此处。',
  'dsar.select_prompt': '请选择请求。',

  'dsar.status.received': '已受理',
  'dsar.status.in_review': '审核中',
  'dsar.status.fulfilled': '已处理',
  'dsar.status.rejected': '已驳回',

  'dsar.type.access': '查阅',
  'dsar.type.correction': '更正',
  'dsar.type.deletion': '删除',
  'dsar.type.restriction': '限制处理',
  'dsar.type.other': '其他',

  'dsar.col.sla': 'SLA',
  'dsar.col.id': '受理编号',
  'dsar.col.status': '状态',
  'dsar.col.type': '类型',
  'dsar.col.locale': '语言',
  'dsar.col.subject': '申请人',
  'dsar.col.preview': '预览',
  'dsar.col.submitted_at': '提交时间',

  'dsar.locale.ko': '한국어',
  'dsar.locale.en': 'English',
  'dsar.locale.zh': '简体中文',

  'dsar.detail.current_status': '当前状态',
  'dsar.detail.id': '受理编号',
  'dsar.detail.type': '类型',
  'dsar.detail.locale': '语言',
  'dsar.detail.subject': '申请人',
  'dsar.detail.contact': '联系方式',
  'dsar.detail.related_report': '关联报告',
  'dsar.detail.assignee': '负责人',
  'dsar.detail.fulfilled_at': '完成时间',
  'dsar.detail.description': '请求内容',
  'dsar.detail.review_note': '审核备注',
  'dsar.detail.rejected_reason': '驳回原因',

  'dsar.action.assign_review': '分配给我并审核',
  'dsar.action.fulfill': '处理完成',
  'dsar.action.reject': '驳回',
  'dsar.modal.fulfill_title': 'DSAR 处理完成',
  'dsar.modal.fulfill_note_label': '审核备注（可选）',
  'dsar.modal.reject_title': 'DSAR 驳回',
  'dsar.modal.reject_reason_label': '驳回原因（必填）',

  'dsar.sla.badge': '30d↑',
  'dsar.sla.exceeded': 'SLA 超时',

  'audit.page_title': '审计日志',
  'audit.empty': '没有匹配的审计日志',
  'audit.empty_sub': '请调整筛选条件或从"全部"预设开始。',
  'audit.select_prompt': '选择行后将显示详情。',

  'audit.filter.action': '操作',
  'audit.filter.action_placeholder': '例: robot.create, auth.*',
  'audit.filter.resource_type': '资源类型',
  'audit.filter.resource_type_placeholder': '例: Robot, CustomerReport',
  'audit.filter.resource_id': '资源 ID',
  'audit.filter.resource_id_placeholder': 'cuid / displayId',
  'audit.filter.entity': '法人',
  'audit.filter.outcome': '结果',
  'audit.filter.from_date': '开始日期',
  'audit.filter.to_date': '结束日期',

  'audit.preset.all': '全部',
  'audit.preset.auth': '认证',
  'audit.preset.robot': '机器人',
  'audit.preset.qr': 'QR',
  'audit.preset.deployment': '部署',
  'audit.preset.report': '报告',
  'audit.preset.dsar': 'DSAR',
  'audit.preset.user': '用户',

  'audit.col.time': '时间',
  'audit.col.action': '操作',
  'audit.col.resource': '资源',
  'audit.col.actor': '操作者',
  'audit.col.entity': '法人',
  'audit.col.outcome': '结果',

  'audit.outcome.success': '成功',
  'audit.outcome.failure': '失败',
  'audit.outcome.failure_badge': '失败',

  'audit.detail.id': 'ID',
  'audit.detail.time': '时间',
  'audit.detail.action': '操作',
  'audit.detail.resource': '资源',
  'audit.detail.resource_id': '资源 ID',
  'audit.detail.actor': '操作者',
  'audit.detail.entity': '法人',
  'audit.detail.outcome': '结果',
  'audit.detail.ip': 'IP',
  'audit.detail.request_id': '请求 ID',
  'audit.detail.error': '错误信息',
  'audit.detail.diff': '负载 (diff)',
  'audit.detail.user_agent': 'User-Agent',
  'audit.detail.system_anonymous': 'system / anonymous',
} as const;

export default zh;
